// Purpose: Initialize and export the Firebase app and Auth instance for use throughout the frontend app.
import { initializeApp, type FirebaseOptions } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase configuration is now dynamically loaded from environment variables
const firebaseConfig: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID, // Optional, remove if not using Analytics
};

// Log which environment's config is being used and check for essential keys
console.log(
  `[FirebaseConfig] Initializing Firebase for environment: ${import.meta.env.VITE_APP_ENV || 'unknown'}`
);
if (!firebaseConfig.apiKey) {
  console.error(
    '[FirebaseConfig] Firebase API Key (VITE_FIREBASE_API_KEY) is missing. Please check your .env file configuration.'
  );
}

// Initialize Firebase and export the app instance for use by other Firebase services (e.g., Remote Config)
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth and export it
export const auth = getAuth(app);
